export default [
  {
    path: '/discovery',
    name: 'Discovery',
    component: () => import('@/views/Discovery/Index'),
    meta: {
      roles: ['distributor'],
    },
    children: [
      {
        path: 'create',
        name: 'DiscoveryCreate',
        component: () => import('@/views/Discovery/Create'),
        meta: {
          roles: ['distributor'],
        },
        children: [
          {
            path: 'goods',
            name: 'DiscoveryCreateGoods',
            component: () => import('@/views/Discovery/Goods'),
            meta: {
              roles: ['distributor'],
            },
          },
        ],
      },
      {
        path: 'goodsDetail/:id',
        name: 'DiscoveryGoodsDetail',
        component: () => import('@/views/GoodsDetail'),
        meta: {
          roles: ['distributor'],
        },
      },
    ],
  },
]